export interface TestAutomationInstallationsListItem {
  installationIds: number[];
  accessUsersIds: string[];
}

export const restrictedTestAutomationInstallations: TestAutomationInstallationsListItem[] = [
  {
    installationIds: [12862],
    accessUsersIds: ['9167eb66-86a1-4df3-bde7-d44301f48a00'],
  },
];
